<template>
    <div>
        <el-carousel :interval="5000" indicator-position="none" height="2.63rem">
            <el-carousel-item v-for="(item, index) in img_arr" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>
        
        <div style="padding: 0 0.3rem; margin-bottom: 0.8rem;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in category_arr" :key="index" :label="item.name" :name="item.id"></el-tab-pane>
            </el-tabs>

            <div>
                <div v-for="(item, index) in data_list" :key="index" class="flx jcsb" style="margin-top: 0.8rem;" @click="toPages2('articledetails2', item.article_id)">
                    <div style="width: 2.8rem; height: 1.68rem;">
                        <img style="width: 2.8rem; height: 1.68rem;" :src="item.format_img" alt="">
                    </div>
                    <div style="width: 6.4rem;">
                        <div class="flx aic jcsb">
                            <div class="dffaaa dv1 tl" style="font-size: 0.4rem; width: 4.3rem;">{{item.article_title}}</div>
                            <span style="font-size: 0.34rem;">{{item.article_year}} {{item.article_date}}</span>
                        </div>
                        <div class="dv2 tl" style="color: #878787; line-height: 0.5rem; font-size: 0.34rem; margin-top: 0.2rem;" v-html="item.article_content"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'IndexPage4',
    data () {
        return {
            data_list: '',
            img_arr: '',
            category_arr: [
                {id: '0', name: '全部'},
                {id: '10', name: '行业资讯'},
                {id: '20', name: '交农动态'},
                {id: '30', name: '校友聚力'},
                {id: '40', name: '农友动态'},
            ],
            activeName: '0',
        }
    },
    methods: {
        getData() {
            this.$post('index.php?s=/api/index/article', {
                wxapp_id: 10001,
                category_type: this.activeName
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        a_data[i].article_content = this.showHtml(a_data[i].article_content);
                        a_data[i].article_content = a_data[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    this.data_list = a_data;
                    this.img_arr = res.data.zxzx_lbtp;
                }
            }) 
        },
        getData2() {
            this.$post('index.php?s=/api/index/article', {
                wxapp_id: 10001,
                category_type: this.activeName
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        a_data[i].article_content = this.showHtml(a_data[i].article_content);
                        a_data[i].article_content = a_data[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    this.data_list = a_data;
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\"")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },
        handleClick(tab) {
            this.activeName = tab.name;
            this.getData2();
        },
        toPages2(page, parameter) {
            this.$router.push({
                path: '/' + page,
                query: {
                    id: parameter
                }
            })
        },
        openweb(e) {
            if(e) {
                var aa = e.split('?');
                aa[0] = aa[0] + 2;
                var bb = aa.join('?');
                window.open(bb)
            }
        },
    },
    created() {
        var data = this.$route.query;
        document.title = data.name;
        this.getData();
    },
    mounted() {

	},
    destroyed() {

    }

}
</script>

<style scoped>
    .dffaaa{
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// src/components/index2/index9.vue